import { Injectable } from '@angular/core';
import { SQLite, SQLiteObject } from '@ionic-native/sqlite/ngx';
import { from, Observable, ReplaySubject } from 'rxjs';
import { first, flatMap } from 'rxjs/operators';
import { AppSettings } from '../../utils/app-settings';
import { prifact_tables } from './prifact-tables';

@Injectable({
  providedIn: 'root'
})
export class SqliteService {

  public sqlAvailable = true;

  constructor(private sqlite: SQLite) {
    this.init();
  }

  private sqlReady: ReplaySubject<boolean> = new ReplaySubject(1);

  private init() {
    this.create().pipe(
      flatMap((db) => {
        return from(db.sqlBatch(prifact_tables))
      }))
      .subscribe((res) => {
        this.sqlReady.next(true);
      });
  }
  private create(): Observable<SQLiteObject> {
    let createPromise = this.sqlite.create({
      name: AppSettings.databaseName,
      location: AppSettings.databaseLocation
    });
    return from(createPromise);
  }
  public query(query: string, params: any): Observable<any> {
    return this.sqlReady.pipe(
      first(),
      flatMap((res) => {
        return this.create();
      }),
      flatMap((db: SQLiteObject) => {
        return from(db.executeSql(query, params));
      }));
  }
}
